import { IComponentOptions, module } from 'angular';
import ToolbarHelperController from './ex-toolbar-helper.controller';

export default module('app.components.ex-toolbar-helper', [])
.component('exToolbarHelper', ToolbarHelperFactory());

function ToolbarHelperFactory(): IComponentOptions {
    return {
        // Je dois faire ça pour éviter une erreur de "mode strict"
        controller: ['aideTechnique', 'donneesEnregistrement', 'profil', ToolbarHelperController],
        controllerAs: 'vm',
        template: require('./ex-toolbar-helper.html')
    };
}
